const AutomaticStuffing = () => {
    return (
      <div>

        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Automatic Insertion
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                Having one facility in Karachi and the other in Lahore, and a capacity to print more than two million 
                impressions and 600,000 insertions of envelopes per day, TCS Printshop facility in Karachi is ISO 9001:2008 & 
                ISO 27001:2005 certified, while the TCS Printshop facility in Lahore is ISO 9001:2008 certified.
              </p>
              
                
            </div>
            <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
              <img src="/MMs/automaticinsertion.jpg" alt="" className="max-w-[100%] rounded-md"/>
            </div>
          </div>
            
        </div>
      </div>
    );
  };
  
  export default AutomaticStuffing;